module.exports = "/packs/she-2342c9de4d395dc99c5b2d68c51bbaa7.png";